import { Accordion, accordionItemBuilder, Box, Text } from '@wix/design-system';
import React from 'react';
import { dataHooks } from '../../utils/datahooks';
import { useAutoScrolling } from '../../utils/use-auto-scrolling';
import { useOnToggleFunctions } from '../../utils/use-on-toggle-functions';
import { PrefixStatusIcon } from './prefix-status-icon';
import { RuleContent } from './rule-content';
export const RulesList = _ref => {
  let {
    ruleResults,
    parentNodeRef,
    expandLabel,
    collapseLabel
  } = _ref;
  const {
    onToggleRule: onToggle,
    isRuleOpen: isOpen,
    selectedRule
  } = useOnToggleFunctions();
  const {
    selectedItemHeaderRef,
    selectedItemContentRef
  } = useAutoScrolling((selectedRule == null ? void 0 : selectedRule.id) ?? null, parentNodeRef);
  const isCustomLabels = expandLabel && collapseLabel;
  const getLabelWithMargin = label => {
    return /*#__PURE__*/React.createElement(Box, {
      marginTop: "2px"
    }, label);
  };
  const getPrefixIconStatus = ruleResult => {
    return /*#__PURE__*/React.createElement(PrefixStatusIcon, {
      ruleResult: ruleResult
    });
  };
  const items = ruleResults.map(ruleResult => {
    return accordionItemBuilder({
      buttonType: isCustomLabels ? 'node' : undefined,
      children: /*#__PURE__*/React.createElement("div", {
        ref: (selectedRule == null ? void 0 : selectedRule.id) === ruleResult.id ? selectedItemContentRef : null
      }, /*#__PURE__*/React.createElement(RuleContent, {
        ruleResult: ruleResult,
        selected: (selectedRule == null ? void 0 : selectedRule.id) === ruleResult.id
      })),
      collapseLabel: collapseLabel ? getLabelWithMargin(collapseLabel) : undefined,
      disabled: (ruleResult.isLoading || ruleResult.disable) ?? false,
      expandLabel: expandLabel ? getLabelWithMargin(expandLabel) : undefined,
      key: ruleResult.id,
      onToggle: () => {
        onToggle(ruleResult.id, ruleResults);
      },
      open: isOpen(ruleResult),
      prefix: getPrefixIconStatus(ruleResult),
      showLabel: 'always',
      suffix: ruleResult.suffix,
      title: /*#__PURE__*/React.createElement("div", {
        "data-hook": ruleResult.label,
        ref: (selectedRule == null ? void 0 : selectedRule.id) === ruleResult.id ? selectedItemHeaderRef : null
      }, /*#__PURE__*/React.createElement(Text, {
        size: "tiny",
        weight: "normal"
      }, ruleResult.label))
    });
  });
  return /*#__PURE__*/React.createElement(Accordion, {
    dataHook: dataHooks.rulesList,
    horizontalPadding: "medium",
    items: items,
    size: "tiny",
    skin: "light",
    transitionSpeed: "fast",
    hideShadow: true
  });
};
//# sourceMappingURL=rules-list.js.map